




















import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import BindAttrs from '@/utils/binds-attrs';
import '@/compiled-icons/checkbox-blank-outline';
import '@/compiled-icons/checkbox-marked';
import '@/compiled-icons/minus-box-outline';

export interface State {
  icon: string;
  color?: 'primary';
  value: boolean | null;
}

@Component({
  mixins: [BindAttrs]
})
export default class AmetrasCheckBoxWithThreeStatesTemplate extends Vue {
  @Prop() marginDefinition!: string;
  @Prop() paddingDefinition!: string;
  @Prop() value!: boolean | string | null; // true / false / null
  @Prop() textAlign!: 'LEFT' | 'RIGHT' | 'CENTER' | 'JUSTIFIED';

  possibleStates: State[] = [
    {
      icon: 'minus-box-outline',
      value: null
    },
    {
      icon: 'checkbox-marked',
      color: 'primary',
      value: true
    },
    {
      icon: 'checkbox-blank-outline',
      value: false
    }
  ];
  currentState: State = this.possibleStates[0];

  created() {
    this.updateCurrentStateBasedOnValue();
  }

  @Watch('value') valueChanged() {
    this.updateCurrentStateBasedOnValue();
  }

  clicked() {
    const nextIndex = this.possibleStates.indexOf(this.currentState) + 1;
    if (nextIndex < this.possibleStates.length) {
      this.currentState = this.possibleStates[nextIndex];
    } else {
      this.currentState = this.possibleStates[0];
    }
    this.$emit('change', this.currentState.value);
    this.$emit('input', this.currentState.value);
  }

  private updateCurrentStateBasedOnValue() {
    if (this.value === true || this.value === 'true') {
      this.currentState = this.possibleStates[1];
    } else if (this.value === false || this.value === 'false') {
      this.currentState = this.possibleStates[2];
    } else {
      // default
      this.currentState = this.possibleStates[0];
    }
  }
}
